import { useSelector } from 'react-redux';
import type { RootState } from '../../../store';
import { HeaderTela } from '../../../components/admin/header-tela';
import { GerenciadorPontosAcesso } from '../../../components/admin/gerenciador-pontos-acesso';

/**
 * Visão da loja INTEIRA: todos os tipos de ponto de acesso numa lista só.
 *
 * Fora do menu lateral — o dia a dia é gerenciar os pontos na aba do próprio
 * modo, e o item duplicava o que já existe lá. A rota fica de pé para links e
 * favoritos antigos, e para quando alguém precisa ver tudo junto.
 *
 * O miolo (listagem, criação, QR, download) mora em `GerenciadorPontosAcesso`,
 * porque as abas de configuração abrem o mesmo conteúdo em um modal — só que
 * recortado ao tipo daquela aba (ver `dialog-pontos-acesso.tsx`).
 */
export function AdminIdentificadorPage(): JSX.Element {
  const idConfig = useSelector((s: RootState) => s.adminAuth.idConfiguracaoSelecionada)!;

  return (
    <GerenciadorPontosAcesso
      idConfig={idConfig}
      cabecalho={(acoes) => (
        <HeaderTela
          titulo="Acessos ao cardápio"
          descricao="QR codes pra mesa, comanda, totem, delivery (subdomínio) e vitrine."
          acoes={acoes}
        />
      )}
    />
  );
}
